const featureFlags = require('../../../../sdk/featureFlags.json');

export const ssrData = {
    data: {
        location: {
            pathname: '/',
        },
        featureFlags_abTests: featureFlags,
        base_urls: {
            main: '//www.manomano.fr',
            cdn: 'https://cdn.manomano.com',
        },
    },
    context: {
        platform: 'fr',
        abState: {},
        user: {
            is_logged: false,
            is_b2b: false,
        },
        requestedHost: 'www.manomano-dev.fr',
    },
};
